export const BlogPostPageMetaData = (title, description) => {
  return {
    title: title,
    description: description,
    image: '%PUBLIC_URL%/android-icon-192x192.png',
    url: 'https://unitconversion.page/blog',
    type: 'website',
  }
}
